"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var react_1 = __importStar(require("react"));
var AppItemsLoader_1 = __importDefault(require("./AppItemsLoader"));
var AppSelectorItems_1 = __importDefault(require("./AppSelectorItems"));
function useAppSelector(anchor, apps) {
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setOpen = _a[1];
    var open = (0, react_1.useCallback)(function () {
        setOpen(true);
    }, []);
    var close = (0, react_1.useCallback)(function () {
        setOpen(false);
    }, []);
    var element = (react_1.default.createElement(Popover_1.default, { open: isOpen, onClose: close, anchorEl: anchor, anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
        } },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2, sx: { p: 2, width: 360 }, alignItems: "stretch" }, typeof apps === 'string' ? react_1.default.createElement(AppItemsLoader_1.default, { appsUrl: apps }) : react_1.default.createElement(AppSelectorItems_1.default, { apps: apps }))));
    return {
        element: element,
        open: open,
    };
}
exports.default = useAppSelector;
